import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './styles.scss'
import { Button, Select, Modal, Spin } from 'antd'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import {
    fetchCloudAccounts,
    fetch_clouds,
    fetch_buckets,
    expandCloudAccount,
    deleteCloudAccount,
} from '../../../actions/cloud-accounts-actions'

class SetBillingBucket extends React.Component {
    constructor(props) {
        super(props)
        this.state = { choice: null, storages: [], saving: false }

        this.setBbRef = React.createRef()
        this.handleSelectChange = this.handleSelectChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleSkip = this.handleSkip.bind(this)
    }

    handleSelectChange(newValue) {
        this.setState({ choice: newValue })
    }

    handleSave() {
        const { id, history } = this.props
        const { choice } = this.state
        if (choice !== null) {
            // the user selected a billing bucket
            this.setState({ loading: false, saving: true })
            Modal.info({
                title: 'Connecting to Billing Bucket',
                content: 'Your AWS billing information is being populated',
                okText: 'Go To Cloud Page',
                className: 'set-bb-modal',
                onOk: () =>
                    history.push(
                        this.props.firstAccount ? '/onboard/firstAccount' : '/'
                    ),
            })
            CloudFlyerAPI.cloud_accounts.setBillingBucket(id, choice).then(() => {
                this.setState({ saving: false })
                if (id) return this.props.fetch_buckets(id)

                let $this = this
                this.props.fetch_clouds(clouds => {
                    for (let key in clouds) {
                        let cloud = clouds[key]
                        $this.props.fetch_buckets(cloud.id)
                    }
                })
            })
        }
    }

    handleSkip() {
        const { history } = this.props
        history.push('/')
    }
    componentDidMount() {
        this.setState({ loading: true })
        const { id } = this.props
        console.log('ID : ', id)
        console.log(this.props.fetch_buckets)
        this.setBbRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
        CloudFlyerAPI.cloud_accounts.buckets(id).then(res => {
            this.setState({ storages: (res || {}).data || {}, loading: false })
        })
    }

    render() {
        const { storages, saving, loading, choice } = this.state
        return (
            <div ref={this.setBbRef} className="set-billing-bucket">
                <Spin spinning={loading}>
                    <p>
                        You now need to configure a billing bucket to show your
                        account costs on CloudFlyer
                    </p>
                    <p>
                        Before selecting a bucket you must manually configure it
                        in AWS
                    </p>
                    <br />
                    <h4>
                        How to manually configure bucket in your AWS console
                    </h4>
                    {/*<p>Enable billing reports to S3 on the target AWS account from the Billing Preferences page in the AWS console:</p>*/}
                    <div>
                        <ol>
                            <li>
                                Go to the Billing Preferences page in the AWS
                                console.
                            </li>
                            <li>
                                Enable <i>Receive Billing Reports</i> by
                                checking the box.
                            </li>
                            <li>
                                Enter the exact name of the bucket which will
                                receive the billing reports in the box. We
                                recommend that you create a new empty bucket for
                                the billing reports as many files will be
                                created within it. Click Verify to ensure the
                                bucket exists. <br />
                                3a. Copy the sample policy to be added to the
                                bucket in the S3 console.
                            </li>
                            <li>Enable all report types.</li>
                        </ol>
                    </div>
                    <div>
                        <Select
                            dropdownMatchSelectWidth={false}
                            onChange={this.handleSelectChange}>
                            {storages.map(s => (
                                <Select.Option
                                    key={s.bucket_name}
                                    value={s.bucket_name}>
                                    {s.bucket_name}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="footer">
                        <Button
                            type="primary"
                            disabled={choice === null}
                            loading={saving}
                            onClick={this.handleSave}>
                            Save and Connect
                        </Button>
                        <Button type="default" onClick={this.handleSkip}>
                            Skip this Step
                        </Button>
                    </div>
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = ({ cloudAccounts }) => cloudAccounts

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCloudAccounts,
            fetch_clouds,
            fetch_buckets,
            expandCloudAccount,
            deleteCloudAccount,
        },
        dispatch
    )

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SetBillingBucket)
)
